import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Notification from 'rc-notification';
import { savePDF } from '@progress/kendo-react-pdf';
import moment from 'moment';
import { Card, CardBody, CardTitle, Col,Button, Container, Row } from 'reactstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import SmallLoader from '../../../shared/components/SmallLoader';
// import history from '../../../App/History';
import PerformanceBySKUTable from './PerformanceBySKUTable';
// import { getSKUData, handleLoader } from '../../../../redux/actions/SKUAction';
import { getPerformanceBySKUData, handleLoader } 
from '../../../redux/actions/PerformanceBySKUAction';
import { searchPositionTrackerTableHeader as tableHeaderData } from "../helper";
import PerformanceBySKUChartShow from './PerformanceBySKUChartShow';

const PerformanceBySKU = ({ dispatch }) => {
  const { t } = useTranslation('common');

  const location = useLocation();

  const { performanceBySKUData, salesChannelFilterData, isLoading } = useSelector(
    ({ PerformanceBySKUReducer, marketPlaceReducer }) =>
    ({
        performanceBySKUData: PerformanceBySKUReducer?.performanceBySKUData,
        salesChannelFilterData: marketPlaceReducer.salesChannel,
        isLoading: PerformanceBySKUReducer?.isLoading
    })
  );


  const previousMonthDate = new Date();
  previousMonthDate.setMonth(previousMonthDate.getMonth() - 3)

  const [selectedSKU, setSelectedSKU] = useState('');
  const [fromDate, setFromDate] = useState(previousMonthDate);
  const [toDate, setToDate] = useState(new Date());
  const [performanceBySKUdata, setPerformanceBySKUdata] = useState([]);

  const skuOption = [];
  const productNameOptions = [];

  // implement PDF generateor //
  const container = React.useRef(null)
  const exportToPDF = () => {
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
     const btnUploadExcel = document.getElementById('dvFilter');
    //  const dvDownloadV = document.getElementById('dvDownload');
     btnUploadExcel.style.display = "none";  
    //  dvDownloadV.style.display = "none";   
    const element = container.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: 5,
      fileName: `Search Position Tracker Report ${new Date().getFullYear()}`,
    })
    btnUploadExcel.style.display = "block"; 
    // dvDownloadV.style.display = "block"; 
  }

  const callApi = () => {   
    dispatch(handleLoader(true));   
    dispatch(getPerformanceBySKUData(
        {            
            sku: selectedSKU && selectedSKU[0]?.value,
            // sku: 'RAEL-LG-02',
            fromDate: moment(fromDate).format('YYYY-MM-DD'),
            toDate: moment(toDate).format('YYYY-MM-DD')            
        }
    ));
  }

  const handleFromDateChange = (date) => {
    setFromDate(date);
  }

  const handleToDateChange = (date) => {
    setToDate(date);
  }

  const handleSKU = (value) => {
    setSelectedSKU(value)
  }

  const handleApplyDate = () => {
    const intFromDate = moment(fromDate).format('YYYYMMDD');
    const intToDate = moment(toDate).format('YYYYMMDD');
    if (intToDate > intFromDate) {
        callApi()
    }
    else {
        Notification.newInstance({}, (notification) => {
            notification.notice({
                content: 'To Date must be greater than From Date.'
            });
        });
    }
}

//   const uploadExcel = () => {
//     history.push('/report/searchPositionTracker/upload')
//   }

  useEffect(() => {
    dispatch(handleLoader(true));
    // dispatch(getSKUData());
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPerformanceBySKUdata(performanceBySKUData && performanceBySKUData.modal 
      && performanceBySKUData.modal.data || []);
  }, [performanceBySKUData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && salesChannelFilterData.length > 0) {
      if (
        performanceBySKUData?.modal?.data?.length > 0
      ) {
        setPerformanceBySKUdata(
            performanceBySKUData.modal.data.filter(
            x =>
              salesChannelFilterData?.length > 0 &&
              salesChannelFilterData?.find(y => (y?.value?.toString() || '')?.toLowerCase()
                === x[OptChennel]?.toLowerCase()),
          ),
        );
      }
    } else {
        setPerformanceBySKUdata(performanceBySKUData && 
        performanceBySKUData.modal && performanceBySKUData.modal.data || []);
    }
  }, [performanceBySKUData, salesChannelFilterData])

  performanceBySKUData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).forEach((data) => {
    data.filterData.forEach((element) => {
        skuOption.push({
            value: element.key,
            label: element.shortValue
        });
    });
  });  


  // let finalData = performanceBySKUdata ?? [];
  let finalData = [];
  if (selectedSKU?.length) {
    const selected = selectedSKU?.reduce((acc, item) => {
      acc[item?.value] = item.value
      return acc
    }, {})
    finalData = performanceBySKUdata.filter(item => selected[item.sku])
  }


  return (
    <Container>
      <Row className="category-sales">
        <Col sm="12">
      <Card className="pb-3">
        <CardBody className="min-w-50 p-3">
          <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">Performance By SKU</h5>
          </div> 
          <Row>
          <Col md="3" className='pr-0'>
            <div className="form__form-group mb-0">
              <span className="form__form-group-label">SKU</span>
              <div className="form__form-group-field">
                <Select
                  value={selectedSKU}
                  options={skuOption}
                  clearable={false}
                  placeholder="Select"
                  className="sku-select_filter-250"
                  onChange={handleSKU}
                  classNamePrefix="react-select"  
                  isMulti                                           
                />                    
              </div>
            </div>
          </Col>
          <Col md="2">
            <div className="form__form-group mb-0">
              <span className="form__form-group-label">From Date</span>
              <div className="form__form-group-field">
              <div className="date-picker" style={{position: 'absolute', zIndex: 3}}>
                <DatePicker
                    className="form__form-group-datepicker"
                    selected={moment(fromDate).toDate()}
                    showPreviousMonths
                    onChange={handleFromDateChange}
                    dateFormat="MM/dd/yyyy"
                    dropDownMode="select"
                    popperPlacement="bottom"
                    withPortal={isMobileOnly}
                />
              </div>
              </div>
            </div>
          </Col>
          <Col md="2">
            <div className="form__form-group mb-0">
              <span className="form__form-group-label">To Date</span>
              <div className="form__form-group-field">
              <div className="date-picker" style={{position: 'absolute', zIndex: 3}}>
                <DatePicker
                    className="form__form-group-datepicker"
                    selected={moment(toDate).toDate()}
                    showPreviousMonths
                    onChange={handleToDateChange}
                    dateFormat="MM/dd/yyyy"
                    dropDownMode="select"
                    popperPlacement="bottom"
                    withPortal={isMobileOnly} 
                  //  style={{position: 'absolute', zIndex: 3}}                    
                />
              </div>
              </div>
            </div>
          </Col> 
          <Col md="1">
            <Button id='btnApply' className="btn btn-sm btn-primary" style={{marginTop: 26, marginLeft: 15, 
              color: 'white'}} title='Upload excel' onClick={handleApplyDate}>Apply</Button>
          </Col>
          <Col md="4" align='right'>            
              <button className="btn btn-sm btn-primary apply-date-button" 
                type="button" style={{marginTop: 22, marginLeft: 15}} title='Export to pdf' 
                disabled={isLoading} onClick={exportToPDF}
                >Export pdf</button>
          </Col>          
        </Row>               
        </CardBody>
      </Card>
      </Col>
      </Row>    
      <div ref={container}>
         <Card className="pb-3">
            <CardBody className="">
              <div className="top-location"
                style={{ minHeight: '400' }}>
                <div >
                  {isLoading ? <div style={{ minHeight: '200px' }}
                    className="row align-items-center justify-content-center">
                    <SmallLoader loading={isLoading} />
                  </div>
                    : 
                    <PerformanceBySKUTable customClass="pt-0"
                      data={finalData}                   
                  />                 
                }
                </div>
              </div>
            </CardBody>
          </Card>
          <Row className="product-table-wrap">        
              <Col sm="12">
                <CardBody>  
                  {isLoading ? 
                      <div style={{ minHeight: '200px' }}
                          className="row align-items-center justify-content-center">
                          <SmallLoader loading={isLoading} />
                      </div> 
                    : <PerformanceBySKUChartShow customClass="pt-0" reactTableData={{ tableHeaderData }}
                    data={finalData}
                  // data={this.state.rows} 
                  />
                  }
                </CardBody>
              </Col>
          </Row>
        </div>
    </Container>
  )
};

PerformanceBySKU.propTypes = {
  dispatch: PropTypes.func.isRequired,
}

export default connect(state => ({
  rtl: state.rtl,
}))(PerformanceBySKU);